
import { defineComponent } from "vue";
import { mapGetters, mapState } from "vuex";
import { ModalName } from "@/store/ui";

export default defineComponent({
  name: "Modal",
  data() {
    return {
      ModalName,
    };
  },
  computed: {
    ...mapState("app", []),
    ...mapState("ui", ["modalShowing", "currentModal"]),
  },
  methods: {
    resumeSyncLoop() {
      console.log("foo");
      this.$store.dispatch("ui/setCurrentModal", ModalName.None);
      this.$store.dispatch("ui/setModalShowing", false);
    },
  },
});
